@if (ruleEngine.disabled()) {
  <coin-v2-dual-pill
    [contentLeft]="currentConditionLabel()"
    [themeColor]="'petrol'"></coin-v2-dual-pill>
} @else {
  <coin-v2-dual-pill
    tabindex="0"
    role="button"
    icon="sync"
    [contentLeft]="currentConditionLabel()"
    [themeColor]="'petrol'"
    [attr.data-testid]="'rule-set-operator-toggle'"
    (keydown.space)="toggleCondition()"
    (keydown.enter)="toggleCondition()"
    (clicked)="toggleCondition()"></coin-v2-dual-pill>
}
